import { AppEnvironment, appEnvironment } from 'utils/env'
import { isTenantSmava } from 'utils/url'
import { clientDetails as clientDetailsFinanzcheck } from './finanzcheck'
import { clientDetails as clientDetailsSmava } from './smava'

export const getClientDetails = () => {
  if (isTenantSmava()) {
    return (
      // @ts-ignore - clientDetailsSmava type needs refinement for dynamic access
      clientDetailsSmava[appEnvironment] ||
      clientDetailsSmava[AppEnvironment.Shared]
    )
  }

  return (
    // @ts-ignore - clientDetailsFinanzcheck type needs refinement for dynamic access
    clientDetailsFinanzcheck[appEnvironment] ||
    clientDetailsFinanzcheck[AppEnvironment.Shared]
  )
}
